<template>
  <div class="a-vg-c--confirmation-modal pop-up">
    <div class="modal-head">
      <slot name="teams"></slot>
      <slot name="bet-type"></slot>
    </div>
    <div class="modal-body">
      <button class="a-vg-c--cta-button a-vg-c--cta-button__danger reset"
      :disabled="!isButtonResetAndConfirmActive"
      @click="onReset()">
        <image-svg :imageName="'close-app'"/>
        {{$t('vdog_reset')}}
      </button>
      <button class="a-vg-c--cta-button a-vg-c--cta-button__success confirm"
      :disabled="!isButtonResetAndConfirmActive"
      @click="onConfirm()">
        <image-svg :imageName="'accept'"/>
        {{$t('vdog_confirm')}}
      </button>
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/main.js'
import EventConstants from '@/constants/Events'
import ImageSVG from '@/components/common/ImageSVG.vue'

import confirmBet from '../../../assets/audio/vSoccer/confirm_bet.mp3'
import resetBet from '../../../assets/audio/vSoccer/reset_bet.mp3'

import vuexStore from '../../../store/vuexStore'

export default {
  components: {
    'image-svg': ImageSVG
  },
  props: {
    eventData: {
      type: Object,
      required: true
    }
  },
  computed: {
    isButtonResetAndConfirmActive: function () {
      return !this.eventData.isBetPlaced && this.eventData.isBettingEnabled
    }
  },
  watch: {
    'eventData.isBettingEnabled' (val) {
      if (!val) {
        this.eventData.activeStake = null
      }
    }
  },
  data () {
    return {
      hasAudioEnabled: vuexStore.state.hasAudioEnabled
    }
  },
  mounted: function () {
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
  },
  methods: {
    onConfirm: function (value) {
      if (this.hasAudioEnabled) {
        var audio = new Audio(confirmBet)
        audio.play()
      }
      if (this.isButtonResetAndConfirmActive && this.eventData.activeStake) {
        eventBus.onConfirmMatch(this.eventData)
        eventBus.onConfirmModalClose()
        this.eventData.isBetPlaced = true
      }
    },
    onReset: function (value) {
      if (this.hasAudioEnabled) {
        var audio = new Audio(resetBet)
        audio.play()
      }
      if (this.eventData.isBettingEnabled && !this.eventData.isBetPlaced) {
        this.eventData.activeStake = null
      }
    }
  },
  created: function () {
    eventBus.$on(EventConstants.VSOCCER_RESET_STAKE_CONFIRM, this.onReset)
  },
  beforeDestroy () {
    eventBus.$off(EventConstants.VSOCCER_RESET_STAKE_CONFIRM, this.onReset)
  }
}
</script>
